<template>
  <div class="full-height">
    <div class="content">
      <img src="@assets/images/logo.svg" alt="Logo" class="logo img-fluid" />
      <h1 class="texto-bienvenida">{{ $t("components.publichome.welcome") }} {{ $t("app_name") }}</h1>
      <img src="@assets/images/pantalla-carga-animada.svg" alt="cargando datos" class="img-fluid" />
    </div>
    <div class="texto-cargando">{{ $t("components.publichome.loading") }}</div>

  </div>
</template>
<script setup lang="ts">
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useIntl } from "@services/i18n/i18nservice";

const router = useRouter();
const intl = useIntl();

onMounted(() => {
  router.push(intl.i18Route({ name: "charge-session-setup" }));
});
</script>
<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

.full-height {
  background: var(--background-default-default, #FFF);
  height: 100dvh;
  display: flex;
  width: 100%;
  padding: 36px var(--spacing-lg, 24px) var(--spacing-lg, 24px);
  flex-direction: column;
  gap: var(--spacing-2xl, 48px);
  align-items: center;
  justify-content: space-between;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-2xl, 48px);

    .logo {
      width: 250px;
    }

    .texto-bienvenida {
      color: var(--text-default-default, #000);
      text-align: center;
      font-size: clamp(var(--font-size-heading-h3), 10vw, var(--font-size-heading-h1, 32px));
      font-style: normal;
      font-weight: 700;
      line-height: var(--line-height-heading-h1, 36px);
    }

  }


  .texto-cargando {
    color: var(--text-default-caption, #667790);
    font-size: var(--font-size-body-sm, 14px);
    font-weight: 400;
    line-height: var(--line-height-body-sm, 18px);
  }

  #shared-common {
    height: 100%;
  }

  .dx-widget.dx-button.dx-button-mode-contained.dx-button-default.d-flex {
    width: 100%;
  }
}
</style>
